export default {
  envStr: 'prodKml',
  appName: '方舟物联网平台',
  apiHost: '/fenydata-java-gateway',
  docUrl: 'http' + '://doc.huadong2.fenydata.com',

}